var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-package-attachments-uploader"},[_c('DroppableResumableUploader',_vm._b({attrs:{"inline":"","accept":".obb","upload-url":_vm.uploadUrl},on:{"upload-done":_vm.emitUploadResponse}},'DroppableResumableUploader',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }